module.exports = __webpack_public_path__ + "static/media/preview.203ea22b.svg";